import {FormControl, TextInput} from 'platform/components';
import {Grid, Show} from 'platform/foundation';
import {useCurrencySymbolFormatter} from 'platform/locale';

import {UseFormReturn, useWatch} from 'react-hook-form';

import {useGetTenantQuery} from '@dms/api/core';
import i18n from '@dms/i18n';
import {EMPTY_PLACEHOLDER} from '@dms/shared';

import {RequiredTestIdProps, suffixTestId} from 'shared/web';

import {DefinitionFormValues} from '../../types/DefinitionFormValues';
import {EnumFieldsCreation} from './EnumFieldsCreation';

interface AdditionalFieldsByTypeProps extends RequiredTestIdProps {
  formApi: UseFormReturn<DefinitionFormValues>;
  control: FormControl<DefinitionFormValues>;
  hasDisabledInputs?: boolean;
}

export function AdditionalFieldsByType(props: AdditionalFieldsByTypeProps) {
  const formatCurrencySymbol = useCurrencySymbolFormatter();

  const {data: tenant} = useGetTenantQuery();
  const valueType = useWatch({control: props.control, name: 'valueType'});

  return (
    <>
      <Show when={valueType === 'money'}>
        <Grid columns={2}>
          <TextInput
            label={i18n.t('general.labels.currencySymbol')}
            value={formatCurrencySymbol(tenant?.currency) || EMPTY_PLACEHOLDER}
            data-testid={suffixTestId('currencySymbol', props)}
            isDisabled
          />
        </Grid>
      </Show>
      <Show when={valueType === 'enum'}>
        <EnumFieldsCreation
          control={props.control}
          formApi={props.formApi}
          data-testid={suffixTestId('enumFieldsCreation', props)}
        />
      </Show>
    </>
  );
}
